import React from 'react';
import { Button, Box } from '@chakra-ui/react';

interface FavoritesButtonProps {
  onClick: (e: React.MouseEvent) => void;
  isFavorite: boolean;
  borderColor?: string;
  iconFillColor?: string;
  iconStrokeColor?: string;
  backgroundColor?: string;
  size?: string;
  position?: 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
  top?: string | number;
  right?: string | number;
}

const FavoritesButton: React.FC<FavoritesButtonProps> = ({
  onClick,
  isFavorite,
  borderColor = '#C6D959',
  iconFillColor = '#C6D959',
  iconStrokeColor = '#C6D959',
  backgroundColor = 'rgba(28, 28, 30, 0.8)',
  size = '34px',
  position = 'absolute',
  top = '10px',
  right = '10px',
}) => {
  return (
    <Box
      position={position}
      top={top}
      right={right}
    >
      <Button
        className="event-favorite-button"
        border={`2px solid ${borderColor}`}
        backgroundColor={backgroundColor}
        onClick={onClick}
        _hover={{
          backgroundColor: backgroundColor.includes('rgba')
            ? backgroundColor.replace(/\d+(\.\d+)?(?=\))/, (match) => {
                const opacity = parseFloat(match);
                return opacity < 1 ? String(opacity + 0.1) : match;
              })
            : backgroundColor
        }}
      >
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
          <path
            d="M8 13.5C8 13.5 1.5 8 1.5 4.5C1.5 2.5 3 1 5 1C6.5 1 8 2.5 8 2.5C8 2.5 9.5 1 11 1C13 1 14.5 2.5 14.5 4.5C14.5 8 8 13.5 8 13.5Z"
            fill={isFavorite ? iconFillColor : 'none'}
            stroke={iconStrokeColor}
            strokeWidth="1.5"
          />
        </svg>
      </Button>
    </Box>
  );
};

export default FavoritesButton;

